(function () {
	// Shared across every carousel on the page, registered exactly once
	// (not per-fetch, not per-section) - tracks how recently the visitor
	// actually touched or scrolled, so lazy-loaded products never get
	// inserted mid-gesture. This is the real signal we want; browser
	// "idle time" (requestIdleCallback) doesn't know about an active
	// finger on the screen, and isn't available on Safari at all.
	let lastInteractionAt = 0;
	const markInteraction = () => {
		lastInteractionAt = Date.now();
	};
	["touchstart", "touchmove", "scroll", "wheel"].forEach((evt) => {
		window.addEventListener(evt, markInteraction, { passive: true });
	});
	const INTERACTION_IDLE_MS = 200;
	const waitForInteractionIdle = (callback) => {
		const check = () => {
			if (Date.now() - lastInteractionAt >= INTERACTION_IDLE_MS) {
				callback();
			} else {
				setTimeout(check, 100);
			}
		};
		check();
	};

	const featuredCollection = () => {
		$(".section-featured-collection").each(function () {
			const section = $(this);
			const id = section.attr("id");
			const box = section.find(".featured_collection");

			const autoplay = box.data("autoplay");
			const mobile = box.data("mobile");
			const stopAutoplay = box.data("stop-autoplay");
			const speed = box.data("speed") * 1000;
			const delay = box.data("delay") * 1000;
			const disableSlider = box.data("disable-slider");
			const perRow = 4;

			// Lazy-loading: only the first batch of products is rendered
			// server-side (see featured-collection.liquid). The rest are
			// fetched in the background via Shopify's Section Rendering API
			// - same pattern already used by <product-recommendations> in
			// global.js - but held in memory and fed into the carousel one
			// real slide at a time, only as the carousel itself advances
			// (a swipe, or autoplay). Fetching is proximity-triggered (below)
			// since that's a pure network call with no layout cost, but
			// INSERTION is deliberately decoupled from vertical scroll
			// entirely - it's tied to the carousel's own slideChange events,
			// which are normally a separate gesture from scrolling the page.
			//
			// Capped at a handful of extra pages: this is a looping
			// carousel, so it never actually needs every product in a
			// large collection loaded to feel complete, and capping it
			// keeps total background work bounded on very large collections.
			const LAZY_MAX_EXTRA_PAGES = 6;
			// Start feeding the next real slide once the visitor is within
			// this many slides of the end of what's currently loaded. Feeds
			// exactly one product at a time - see feedCardsIntoCarousel for
			// how position drift on desktop's wider breakpoint is corrected
			// without needing to batch these up.
			const LAZY_FEED_THRESHOLD = 3;
			const LAZY_FEED_BATCH_SIZE = 1;
			const lazyDataEl = section[0].querySelector(".featured_collection__lazy-data");
			const lazySectionId = lazyDataEl ? lazyDataEl.dataset.sectionId : null;
			const lazyTotalPages = lazyDataEl
				? Math.min(parseInt(lazyDataEl.dataset.totalPages, 10), 1 + LAZY_MAX_EXTRA_PAGES)
				: 0;
			const lazyInitialCount = lazyDataEl ? parseInt(lazyDataEl.dataset.initialCount, 10) : 0;

			let swiperInstance = box.data("swiperInstance");
			const storageKey = `swiper-pos-${id}`;

		
			const initSwiper = () => {
				if (swiperInstance) return; 

				let autoplayParm = autoplay
					? {
						autoplay: {
							delay: delay,
							pauseOnMouseEnter: stopAutoplay,
							disableOnInteraction: false,
						},
					}
					: {};

				const slideCount = box.find(".swiper-slide").length;
				const saved = sessionStorage.getItem(storageKey);
				const startSlide = (saved !== null && parseInt(saved, 10) < slideCount)
					? parseInt(saved, 10)
					: 0;

				let swiperParms = {
					speed: speed,
					slidesPerView: mobile,
					loop: true,
					loopAdditionalSlides: perRow,
					initialSlide: startSlide,
					keyboard: true,
					breakpoints: {
						576: {
							slidesPerView: perRow >= 2 ? 2 : 1,
						},
						750: {
							slidesPerView: perRow >= 3 ? 3 : perRow,
						},
						990: {
							slidesPerView: perRow >= 4 ? 4 : perRow,
						},
						1150: {
							slidesPerView: perRow,
						},
					},
					navigation: {
						nextEl: `#${id} .swiper-button-next`,
						prevEl: `#${id} .swiper-button-prev`,
					},
					pagination: {
						el: `#${id} .swiper-pagination`,
						type: "progressbar",
					},
					mousewheel: { forceToAxis: true },
					...autoplayParm,
					on: {
						afterInit: function (swiper) {
							// Only wait for the images that will actually be
							// visible at the start position - not the whole
							// slider, not the loop clones.
							const visibleSlides = swiper.slides.filter(
								(slide) => slide.classList.contains("swiper-slide-visible") ||
									slide.classList.contains("swiper-slide-active")
							);
							const targets = visibleSlides.length ? visibleSlides : [swiper.slides[swiper.activeIndex]];

							const imgs = [];
							targets.forEach((slideEl) => {
								slideEl.querySelectorAll("img").forEach((img) => imgs.push(img));
							});

							const reveal = () => {
								box.find(".featured_collection_swiper-list").css("visibility", "visible");
							};

							if (imgs.length === 0) {
								reveal();
								return;
							}

							let remaining = imgs.length;
							const checkDone = () => {
								remaining -= 1;
								if (remaining <= 0) reveal();
							};

							imgs.forEach((img) => {
								if (img.complete) {
									checkDone();
								} else {
									img.addEventListener("load", checkDone, { once: true });
									img.addEventListener("error", checkDone, { once: true });
								}
							});

							// Don't wait forever if an image stalls
							setTimeout(reveal, 800);
						},
						slideChange: function () {
							sessionStorage.setItem(storageKey, this.realIndex);
						},
						// Fires after a swipe (or autoplay tick) has fully
						// settled - the moment to check whether the carousel is
						// running low on loaded real slides and, if so, feed in
						// the next one from the background-fetched buffer.
						slideChangeTransitionEnd: function (swiperInst) {
							const insertedRealCount = box.data("fcInsertedRealCount");
							if (insertedRealCount == null) return;
							if (swiperInst.realIndex >= insertedRealCount - 1 - LAZY_FEED_THRESHOLD) {
								maybeFeedCarousel();
							}
						},
					},
				};

				swiperInstance = new Swiper(`#${id} .swiper`, swiperParms);
				box.data("swiperInstance", swiperInstance);

				if (!document.getElementById("featured-collection-progressbar-style")) {
					const styleTag = document.createElement("style");
					styleTag.id = "featured-collection-progressbar-style";
					styleTag.textContent = `
						.swiper-pagination.swiper-pagination-default {
							padding: 0.3rem 0;
						}
						.featured_collection .swiper-pagination-progressbar {
							border-radius: 999px;
							overflow: hidden;
							background: rgba(184, 184, 184, 0.2);
						}
						.featured_collection .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
							border-radius: 999px;
							background: #b4b4b4ff;
						}
					`;
					document.head.appendChild(styleTag);
				}
			};
		(function () {
			function adjustButtonPosition(height) {
				document
					.querySelectorAll(`.featured_collection .swiper-button`)
					.forEach((button) => {
						button.style.top = height / 2 + "px";
					});
			}
			function changePosition() {
				if (window.innerWidth < 1150) return;
				const image = document.querySelector(`.featured_collection .media img`);
				if (image) {
					if (image.tagName === "IMG") {
						if (image.complete) {
							adjustButtonPosition(image.offsetHeight);
						} else {
							image.addEventListener("load", function () {
								adjustButtonPosition(this.offsetHeight);
							});
						}
					} else if (image.tagName === "svg") {
						const height = image.getBoundingClientRect().height;
						adjustButtonPosition(height);
					}
				}
			}
			changePosition();
			document.addEventListener("shopify:section:load", changePosition);
			let resizeTimeout;
			window.addEventListener("resize", function () {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(changePosition, 100);
			});
		})();
			const destroySwiper = () => {
				if (!swiperInstance) return;

				swiperInstance.destroy(true, true);
				swiperInstance = null;
				box.removeData("swiperInstance");
			};

			// Inserts one (or a few) cards into the running carousel right
			// now. Freezes the container's height around the mutation and
			// only releases it once the visitor is idle - a newly appended
			// slide can be taller than what's currently shown, and without
			// this the container would grow immediately, shifting everything
			// below it on the page.
			const insertCardsNow = (cards, onDone) => {
				waitForInteractionIdle(() => {
					requestAnimationFrame(() => {
						const listEl = box.find(".featured_collection_swiper-list").get(0);
						const lockedHeight = listEl ? listEl.getBoundingClientRect().height : 0;
						if (listEl && lockedHeight > 0) {
							listEl.style.height = `${lockedHeight}px`;
						}

						const currentSwiper = box.data("swiperInstance");
						if (currentSwiper) {
							// Loop mode manages internal clone slides itself -
							// appendSlide() is the safe, documented way to add
							// real slides without corrupting that.
							currentSwiper.appendSlide(cards.map((card) => card.outerHTML));
						} else {
							// Mobile grid fallback (disable_slider setting): append
							// as plain grid children, same as the existing
							// destroySwiper() conversion does for the initial slides.
							const gridWrapper = box.find(".featured_collection--products-grid").get(0);
							if (gridWrapper) {
								cards.forEach((card) => {
									card.classList.remove("swiper-slide");
									gridWrapper.appendChild(card);
								});
							}
						}

						if (listEl && lockedHeight > 0) {
							waitForInteractionIdle(() => {
								listEl.style.height = "";
								onDone();
							});
						} else {
							onDone();
						}
					});
				});
			};

			// The JIT single-card path deliberately skips the interaction-
			// idle wait that insertCardsNow uses. That wait exists to avoid
			// disrupting VERTICAL page scrolling - but swiping the carousel
			// itself is also "touch activity", so during normal continuous
			// browsing it would never see 200ms of total stillness and the
			// insert would just stall forever, which is exactly why the
			// carousel stopped growing once it ran out of real slides.
			// slideChangeTransitionEnd already means THIS swipe's animation
			// has fully settled, which is a good enough safe moment on its
			// own; the height-freeze below still guards against any layout
			// shift from the newly added slide.
			const feedCardsIntoCarousel = (cards, onDone) => {
				requestAnimationFrame(() => {
					const listEl = box.find(".featured_collection_swiper-list").get(0);
					const lockedHeight = listEl ? listEl.getBoundingClientRect().height : 0;
					if (listEl && lockedHeight > 0) {
						listEl.style.height = `${lockedHeight}px`;
					}

					const currentSwiper = box.data("swiperInstance");
					if (currentSwiper) {
						const hasAutoplay = autoplay && currentSwiper.autoplay;

						// Cancel any pending autoplay tick BEFORE mutating the
						// slides, rather than trying to correct the position
						// afterwards. A timer armed against the old slide count
						// can fire mid-mutation and land somewhere stale - and
						// correcting after the fact turned out to be unreliable
						// too (realIndex itself can be the very thing that's out
						// of sync on desktop's tighter loop-clone ratio, so
						// "correcting" to it could snap to the wrong place - that
						// was the cause of the visible backward flash). Stopping
						// the timer first means there's nothing to race against.
						if (hasAutoplay) {
							currentSwiper.autoplay.stop();
						}

						currentSwiper.appendSlide(cards.map((card) => card.outerHTML));
						currentSwiper.update();

						if (hasAutoplay) {
							currentSwiper.autoplay.start();
						}
					}

					requestAnimationFrame(() => {
						if (listEl && lockedHeight > 0) {
							listEl.style.height = "";
						}
						onDone();
					});
				});
			};

			// Takes a small batch out of the background-fetched buffer and
			// inserts it. Called from the carousel's own
			// slideChangeTransitionEnd handler above, never from scroll
			// events - that's the whole point. Guarded so only one insert
			// can be in flight at a time per section; if several
			// slideChange events fire in quick succession the later ones
			// simply no-op, and the next one re-checks and catches up.
			const maybeFeedCarousel = () => {
				const buffer = box.data("fcCardBuffer") || [];
				if (!buffer.length) return;
				if (box.data("fcInsertBusy")) return;

				box.data("fcInsertBusy", true);
				const nextCards = buffer.splice(0, LAZY_FEED_BATCH_SIZE);
				box.data("fcCardBuffer", buffer);

				feedCardsIntoCarousel(nextCards, () => {
					const current = box.data("fcInsertedRealCount") || lazyInitialCount;
					box.data("fcInsertedRealCount", current + nextCards.length);
					box.data("fcInsertBusy", false);
				});
			};

			// Fetches every remaining page in the background - pure network
			// + parsing, no DOM writes, so no layout/jank risk - and holds
			// the parsed cards in a per-section buffer. In normal carousel
			// mode nothing gets inserted here; maybeFeedCarousel() drains
			// the buffer separately as the carousel actually advances. The
			// mobile grid fallback has no "advancing" to hook into, so it
			// still shows everything as it arrives, like earlier versions.
			const fetchAllRemainingPages = () => {
				if (!lazySectionId || lazyTotalPages <= 1) return;
				if (box.data("fcFetchStarted")) return;
				box.data("fcFetchStarted", true);
				box.data("fcCardBuffer", []);
				box.data("fcInsertedRealCount", lazyInitialCount);

				const fetchPage = (page) => {
					if (page > lazyTotalPages) return;

					fetch(`${window.location.pathname}?section_id=${lazySectionId}&page=${page}`)
						.then((response) => response.text())
						.then((html) => {
							const parsed = new DOMParser().parseFromString(html, "text/html");
							const newCards = Array.from(
								parsed.querySelectorAll(".featured_collection__cards.swiper-slide")
							);
							if (!newCards.length) return Promise.resolve();

							if (box.data("swiperInstance")) {
								const buffer = box.data("fcCardBuffer") || [];
								box.data("fcCardBuffer", buffer.concat(newCards));
								return Promise.resolve();
							}

							return new Promise((resolve) => {
								insertCardsNow(newCards, resolve);
							});
						})
						.catch((e) => {
							console.error(`[featured-collection] failed loading page ${page}`, e);
						})
						.finally(() => {
							fetchPage(page + 1);
						});
				};

				fetchPage(2);
			};

			// Starts the background fetch once the carousel is getting
			// close to the viewport, so we don't spend network on carousels
			// the visitor may never scroll to. Mirrors the
			// ProductRecommendations IntersectionObserver pattern in
			// global.js. This only starts the FETCH - insertion is entirely
			// separate, see maybeFeedCarousel above.
			const observeAndFetchRemaining = () => {
				if (!lazySectionId || lazyTotalPages <= 1) return;
				if (box.data("fcFetchObserverAttached")) return;
				box.data("fcFetchObserverAttached", true);

				new IntersectionObserver(
					(entries, observer) => {
						if (!entries[0].isIntersecting) return;
						observer.disconnect();
						fetchAllRemainingPages();
					},
					{ rootMargin: "0px 0px 400px 0px" }
				).observe(this);
			};

			if (disableSlider && window.innerWidth <= 576) {
				destroySwiper();

				const wrapper = box.find(".swiper-wrapper");
				wrapper.removeClass("swiper-wrapper").addClass("featured_collection--products-grid");
				wrapper.children().removeClass("swiper-slide");

				box.find(".swiper-button-next, .swiper-button-prev, .swiper-pagination")
					.css("display", "none");

				box.find(".featured_collection_swiper-list").css("visibility", "visible");
			} else {
				const wrapper = box.find(".featured_collection--products-grid");
				if (wrapper.length) {
					wrapper.removeClass("featured_collection--products-grid").addClass("swiper-wrapper");
					wrapper.children().addClass("swiper-slide");
				}

				box.find(".swiper-button-next, .swiper-button-prev, .swiper-pagination")
					.css("display", "");

				initSwiper();
			}

			observeAndFetchRemaining();
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		featuredCollection();
		document.addEventListener("shopify:section:load", function () {
			featuredCollection();
		});

		// Absolute fallback: ensure nothing stays hidden forever
		setTimeout(function () {
			document
				.querySelectorAll(".featured_collection_swiper-list")
				.forEach((el) => (el.style.visibility = "visible"));
		}, 600);

		let resizeTimeout;
		window.addEventListener("resize", function () {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(featuredCollection, 200);
		});
	});
})();